import { SearchIcon } from '@heroicons/react/outline';
import { MenuIcon } from '@heroicons/react/solid';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Login from './Login';
import Register from './Register';
import CartModal from './CartModal';


function Nav() {
  const [toggle, setToggle] = useState(false),
    [currency, setCurrency] = useState(false),
    [language, setLanguage] = useState(false);
  return (
    <nav className="w-full z-30  top-0">

      <div className="w-full  p-2 h-12">
        <div className="justify-between ">
          <div className="w-1/2 inline-block p-2">
            <h2 className="text-sm text-gray-700">Call us: (+233)-356-4578</h2>
          </div>
          <div className="w-1/2 gap-2 justify-end float-right hidden lg:inline-flex  text-sm text-gray-800 ">
            <button className="p-2">
              <span className="">My Account</span>
            </button>
            <button className="p-2">
              <span className="">Check Out</span>
            </button>
            <button className="p-2 mr-2 ">
              <span className="" onClick={() => setCurrency(!currency)}>
                Currency: GHC
              </span>
              {currency ? (
                <div className="flex flex-col bg-slate-600 p-2 rounded-b-md z-auto">
                  <span className="text-gray-50 text-sm font-semibold capitalize">
                    Cedis
                  </span>
                  <span className="text-gray-50 text-sm font-semibold capitalize">
                    dollars
                  </span>
                  <span className="text-gray-50 text-sm font-semibold capitalize">
                    pounce
                  </span>
                </div>
              ) : (
                ''
              )}
            </button>
            <button className="p-2 ">
              <span className="" onClick={() => setLanguage(!language)}>
                Languages:
              </span>
              {language ? (
                <div className="flex flex-col bg-slate-600 p-2 rounded-b-md">
                  <span className="text-gray-50 text-sm font-semibold capitalize">
                    English
                  </span>
                  <span className="text-gray-50 text-sm font-semibold capitalize">
                    French
                  </span>
                  <span className="text-gray-50 text-sm font-semibold capitalize">
                    Spanish
                  </span>
                </div>
              ) : (
                ''
              )}
            </button>
          </div>
          <span className="justify-end lg:hidden">check Out</span>
        </div>
      </div>

      <div className="border-t-1 flex lg:flex-row w-full lg:h-20 text-white items-center bg-[#fb9815] mb-2 px-6 flex-col justify-between py-3">
        <div className="p-2 flex-1">
          <h2 className="text-2xl lg:text-3xl font-bold w-full">Shops <b className="text-black">Ghana</b></h2>
        </div>
        <div className="flex w-full justify-between  flex-row gap-1">
          <MenuIcon className="h-6 w-6" />
          <div className="border ring-blue-300 rounded-full ">
            <input
              type="text"
              placeholder="Search for an item"
              className=" rounded-full w-5/6 lg:px-20  lg:py-2 px-2 pl-2 py-1  text-gray-800 lg:inline-block outline-none  ring-1 ring-gray-300"
            />
            {/* <select
              className="border-l p-1 bg-gray-500 lg:inline-flex hidden outline-none
           "
            >
              <option className="outline-none text-blue-900">
                All Categories
              </option>
            </select> */}
            <button className="float-right rounded-r-lg   text-gray-100 p-1 lg:p-2 md:px-3 text-lg">
              <SearchIcon className="w-6 h-6 font-bold " />
            </button>
          </div>
          <div className="ml-4  text-white text-right flex flex-row">
            {/* <SearchIcon className="w-6 h-6" /> */}

           
            <CartModal />
          </div>
        </div>
      </div>

      <div className="bg-[#fb9815] p-3 w-full  lg:flex border lg:text-center">
        {/* <div className="lg:hidden text-gray-100 p-2">
          <h2 className="lg:hidden p-2 w-1/2 inline pb-4 text-gray-100 font-bold">
            Shops Ghana
          </h2>
          <div className=" border float-right p-1  text-gray-100">
            <svg
              className="w-6 h-6 float-right"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </div>
        </div> */}
        <div className="w-full font-bold flex justify-between  ">
          <div className="flex  text-gray-100 ">
            <button
              onClick={() => setToggle(!toggle)}
              className="lg:ml-32 lg:mr-4 text-lg p-2 flex"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                ></path>
              </svg>
              All Categories
            </button>

            <div
              className={`${
                !toggle ? 'hidden' : 'inline'
              } flex flex-col mt-2 lg:mt-0 lg:flex lg:flex-row`}
            >
              <Link to="/">
                <button className="p-2 bg-black md:text-lg rounded-lg text-sm lg:inline   ">
                  Home
                </button>
              </Link>
              <Link to="/Shop">
                {' '}
                <button className="p-2 hover:bg-black md:text-lg rounded-lg transition duration-500 ease-in text-sm lg:inline  ">
                  Shop
                </button>
              </Link>
              <Link to="/about">
                <button className="p-2 hover:bg-black md:text-lg rounded-lg transition duration-500 ease-in text-sm lg:inline  ">
                  About Us
                </button>
              </Link>
              <Link to="/contact">
                <button className="p-2 hover:bg-black md:text-lg rounded-lg transition duration-500 ease-in text-sm lg:inline  ">
                  Contact Us
                </button>
              </Link>
            </div>
          </div>
          <div
            className={`${
              !toggle ? 'hidden' : 'inline'
            }  lg:inline-flex text-gray-100`}
          >
            <Login />
            <Register />
          </div>
        </div>
        <div className="hidden absolute left-0 bg-gray-100 shadow-md divide-y border goup-hover:block w-full mt-8 z-30">
          <ul className="p-2">
            <li className="text-gray-800 pt-2 pb-2">Bedroom</li>
            <li className="text-gray-800 pt-2 pb-2">Bedroom</li>
            <li className="text-gray-800 pt-2 pb-2">Bedroom</li>
            <li className="text-gray-800 pt-2 pb-2">Bedroom</li>
            <li className="text-gray-800 pt-2 pb-2">Bedroom</li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
